import React from 'react'
import PropTypes from 'prop-types'

// VideoSection: A component that displays embedded video with custom thumbnail.
export default function VideoSection({ section }) {
  const { thumbnail_url, video_url } = section
  const hasThumbnail = Boolean(thumbnail_url)

  function buildVideoSrc(url, hasPoster) {
    let id = null

    if (url.includes('youtube.com/watch')) id = url.split('v=')[1]
    if (url.includes('youtu.be/')) id = url.split('youtu.be/')[1]

    if (id) {
      id = id.split('&')[0].split('?')[0]
      return `https://www.youtube.com/embed/${
        id
      }?playsinline=1&rel=0&modestbranding=1&controls=0`
    }

    return `${url}&muted=1&title=0&byline=0&portrait=0&color=d01e2f&controls=${
      hasPoster ? 0 : 1
    }`
  }

  function playVideo(poster) {
    const iframe = poster.previousElementSibling
    const currentSrc = iframe.src
    const newSrc = currentSrc.replace('controls=0', 'controls=1&autoplay=1')
    iframe.src = newSrc

    poster.style.display = 'none'
  }

  return (
    <section>
      <div className="container contentWrapper_small">
        <div
          className={`video js-video${hasThumbnail ? ' videoWithPoster' : ''}`}
        >
          <iframe
            allow="autoplay; fullscreen"
            className="videoIframe lazyload js-videoIframe"
            loading="lazy"
            src={buildVideoSrc(video_url, hasThumbnail)}
            title="Vimeo video player"
          />
          {hasThumbnail && (
            <div
              className="videoPoster js-videoPoster"
              onClick={(e) => playVideo(e.currentTarget)}
              style={{ backgroundImage: `url(${thumbnail_url})` }}
            />
          )}
        </div>
      </div>
    </section>
  )
}

VideoSection.propTypes = {
  section: PropTypes.shape({
    thumbnail_url: PropTypes.string.isRequired,
    video_url: PropTypes.string.isRequired,
  }).isRequired,
}
